import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { setError } from 'slices/typeSlice';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import FullPageLoader from 'components/common/FullPageLoader';
import { Switch } from '@mui/material';
import Api from 'services/api';
import { fetchAccessesList } from 'slices/permissionGroupSlice';
import { PermissionSelector } from 'slices/permissionGroupSlice';
import { addPermissionGroup } from 'slices/permissionGroupSlice';
import { updatePermissionGroup } from 'slices/permissionGroupSlice';
import ErrorMessage from 'components/common/ErrorMessage';
const apiService = new Api();

const SwitchGroup = ({ name, control, label, handlePermissionChange }) => {
  return (
    <div className='d-flex align-content-center gap-2'>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Switch
            name={name}
            checked={field.value || false}
            onChange={(e) => {
              field.onChange(e.target.checked);
              handlePermissionChange(e.target.checked, name); // 🛠 Fix applied here
            }}
            color='primary'
          />
        )}
      />
      <h3 className='mt-0'>{label}</h3>
    </div>
  );
};


const AddGroups = ({ item, loader, error }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const methods = useForm({ defaultValues: {} });
  const { handleSubmit, control, setValue, watch ,formState:{errors}} = methods;
  const [status, setStatus] = useState(1);
  const [allChecked, setAllChecked] = useState(false);
  const { accessList, loader:accessLoader } = useSelector(PermissionSelector);
  useEffect(() => {
    dispatch(fetchAccessesList())
  }, []);

  useEffect(() => {
    setValue('name', item?.name || '');
    setValue('select_all', item?.select_all || 0);
    setAllChecked(item?.select_all == 1 ? true : false)
    if (item?.permissions) {
      item.permissions.forEach((perm) => {
        const permissionKey = `${perm.access.page_name.replaceAll(' ', '_').toLowerCase()}_${perm.access.id}`;
        setValue(permissionKey, true);
      });
    }
  }, [item, setValue]);

  const handleSelectAll = () => {
    const newCheckedState = !allChecked;
    setAllChecked(newCheckedState);
    accessList?.forEach((page) => {
      page?.accesses.forEach((perm) => {
        setValue(`${page?.page_name?.replaceAll(' ', '_').toLowerCase() + '_' + perm?.id}`, newCheckedState);
      });
    });
  };

  const handlePermissionChange = (checked, name) => {
    const allPermissions = accessList?.flatMap((page) =>
      page?.accesses.map((perm) =>
        watch(`${page?.page_name?.replaceAll(' ', '_').toLowerCase()}_${perm?.id}`)
      )
    );
    const isAllChecked = allPermissions.every((perm) => perm);
    setAllChecked(isAllChecked);
    setValue('select_all', isAllChecked ? 1 : 0);
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      navigate(-1)
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}));

    const selectedPermissions = accessList?.flatMap((page) =>
      page?.accesses
        .filter((perm) => watch(`${page?.page_name?.replaceAll(' ', '_').toLowerCase() + '_' + perm?.id}`))
        .map((perm) => perm?.id)
    );

    const newData = {
      name: data.name,
      select_all: data.select_all,
      status: status,
      ids: selectedPermissions,
    };
    if (item?.id) {
      dispatch(updatePermissionGroup(newData, item?.id, submitCallback));
    } else {
      dispatch(addPermissionGroup(newData, submitCallback));
    }
  };

  return (
    <FormProvider {...methods}>
      <form className='card_table p-4' onSubmit={handleSubmit(onSubmit)}>
        <div className='row-primary'>
          <h2>Permission Group Name *</h2>
          <div className='w-100' style={{ maxWidth: '400px' }}>
            <Controller
              name="name"
              rules={{ required: "Please Enter name" }}
              control={control}
              render={({ field }) => <input  className="input-in type_inp" type="text" name='name' placeholder='Group Name' {...field}/>}
            />
            {
              errors?.name?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.name?.message} />
              </div>
            }

          </div>
          <h3>Select all</h3>
          <Controller
            name="select_all"
            control={control}
            render={({ field }) => (
              <Switch
                checked={allChecked}
                onChange={(e) => {
                  const newValue = e.target.checked ? 1 : 0;
                  handleSelectAll();
                  field.onChange(newValue);
                }}
                color="primary"
              />
            )}
          />

        </div>

        {accessList?.map((page, index) => (
          <div className='permission_area row-primary' key={index}>
            <h2 className='mt-3 text-transform-capitalize'>{page?.page_name}</h2>
            <div className='switch_wrapper'>
              {page?.accesses?.map((perm) => (
                <SwitchGroup
                  key={perm?.id}
                  control={control}
                  label={perm?.name}
                  name={`${page?.page_name?.replaceAll(' ', '_').toLowerCase()}_${perm?.id}`}
                  handlePermissionChange={handlePermissionChange}
                />
              ))}
            </div>
          </div>
        ))}


        <div className="row-primary align-items-center template_switch">
          <h2 className='mt-0'>Status</h2>
          <CustomSwitch
            labelText="active"
            checked={status == 1 ? true : false}
            handleChange={(checked) => setStatus(checked ? 1 : 0)}
          />
        </div>

        <div className='Form-footer'>
          <SubmitButton loader={loader} btnText={item?.id ? 'Update' : 'Create'} />
        </div>
      </form>
      {accessLoader && <FullPageLoader />}
    </FormProvider>
  );
};

export default AddGroups;